module.exports = __webpack_public_path__ + "img/secret-film@2x.99396df4.png";